import { Label } from '@neo4j-ndl/react';
import { FleetManagementTypes } from '@nx/state';
import cx from 'classnames';

export const getStatusColor = (status: FleetManagementTypes.Api.DEPLOYMENT_STATUS) => {
  switch (status) {
    case FleetManagementTypes.Api.DEPLOYMENT_STATUS.RUNNING:
      return 'success';
    case FleetManagementTypes.Api.DEPLOYMENT_STATUS.DEGRADED:
      return 'warning';
    default:
      return 'danger';
  }
};

export const DeploymentStatus = ({ status }: { status: FleetManagementTypes.Api.DEPLOYMENT_STATUS }) => {
  return (
    <Label
      fill="clean"
      hasIcon
      color={getStatusColor(status)}
      className={cx('truncate font-normal uppercase [&_.ndl-icon-svg]:shrink-0', {
        '[&_.ndl-label-text]:!text-success-text': status === FleetManagementTypes.Api.DEPLOYMENT_STATUS.RUNNING,
        '[&_.ndl-label-text]:!text-neutral-text-weaker': status !== FleetManagementTypes.Api.DEPLOYMENT_STATUS.RUNNING,
      })}
    >
      {status}
    </Label>
  );
};
